import { Paper, TextField, Button, Box} from "@mui/material";
import styled from "styled-components";

export const StyleTextField = styled(TextField)`
  margin-bottom: 10px;
  border-radius: 20px;
  width: 200px;
`;

export const StyledBox = styled(Box)`
  max-height: 200px; 
  overflow-y: scroll; 
  margin-top: 10px;
`;

export const SearchRow = styled.div`
  margin: 5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FormElement = styled.div`
  margin: 15px 0;
`;
